export const SUBMIT_BUTTON_ID = "login-submit";
export const LOGOUT_BUTTON_ID = "logout-button";
